import { Icon, MessageBar, MessageBarType, PrimaryButton, Spinner } from "@fluentui/react";
import { TextField, useTheme } from "cayo.ui";
import React, { Dispatch } from "react";
import { useIntl } from "react-intl";
import styled from "styled-components";
import { messages } from "../messages";

interface ICreateApplication {
  dispatchWizardState: Dispatch<{ type: string; payload: any }>;
  wizardState: any;
  grantConsent: () => void | undefined;
  consentState: string;
  isChecking?: boolean;
  principalLimitError?: string;
}

export const CreateApplication = ({
  consentState,
  isChecking,
  wizardState,
  principalLimitError,
  grantConsent,
  dispatchWizardState,
}: ICreateApplication) => {
  const intl = useIntl();
  const { cayoTheme } = useTheme();
  const { grantUrl, consentError } = wizardState;
  const error = consentError;

  return (
    <View>
      {error && (
        <MessageBar messageBarType={MessageBarType.error} truncated={false} isMultiline>
          {error}
        </MessageBar>
      )}

      <MessageBar
        messageBarType={MessageBarType.info}
        truncated={true}
        styles={{
          root: {
            margin: "10px 0 10px 0",
            background: cayoTheme.wizard.colors.active,
          },
        }}
      >
        {intl.formatMessage(messages.createApplicationInfo)}
      </MessageBar>

      <Wrapper>
        <Label>{intl.formatMessage(messages.createApplicationSignInLabel)}</Label>
        <Block>
          <PrimaryButton
            text={intl.formatMessage(messages.createApplicationSignIn)}
            onClick={grantConsent}
            disabled={!grantUrl || isChecking}
            styles={{ root: { marginTop: 10, marginBottom: 10 } }}
          />
          <GrantState
            className={consentError ? "invalid" : consentState === "granted" ? "granted" : ""}
          >
            {consentError && !isChecking ? (
              <Icon iconName="ErrorBadge" />
            ) : consentState === "granted" ? (
              <Icon iconName="Completed" />
            ) : (
              ""
            )}
            {isChecking && <Spinner label={""} labelPosition="right" />}
          </GrantState>
        </Block>
      </Wrapper>

      <>
        <TextField
          label={intl.formatMessage(messages.accountField)}
          tooltip={intl.formatMessage(messages.accountFieldTooltip)}
          required
          value={wizardState?.principalAccountName}
          errorMessage={principalLimitError}
          className="principal-account-name"
          setValue={(value) =>
            dispatchWizardState({
              type: "update",
              payload: {
                principalAccountName: value,
              },
            })
          }
        />
      </>
    </View>
  );
};

const View = styled.div`
  label {
    &::after {
      padding-right: 0 !important;
    }
  }
`;

const Label = styled.span`
  font-weight: 600;
`;

const Block = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 15px 0 15px 0;
`;

const GrantState = styled.span`
  font-weight: 500;
  display: flex; 
  gap 10px;
  align-items: center;

  .consent {
    color: rgb(50, 49, 48) !important;
  }

  &.granted {
    color: ${(props) => props.theme.cayoTheme.brandColors.success};
  }

  &.invalid {
    color: ${(props) => props.theme.cayoTheme.brandColors.error};
  }
`;
